import { Link } from "react-router-dom";
import RightArrow from "../../components/SVG";
import { Pagination } from "../../components/admin/common/PaginationNumber";

const EducationSection = ({
  educationsData,
  degrees,
  isFetching,
  currentPage,
  selectedDegree,
  onPageChange,
  onDegreeFilter,
  educationalProgramsRef, // Add ref prop
}) => {
  console.log(educationsData, "educationsData");
  console.log(degrees, "degrees");

  // Fixed: Correct data extraction from API response structure
  const educations = educationsData?.data?.educations || [];
  const totalPages = educationsData?.data?.pagination?.totalPages || 1;
  const totalCount = educationsData?.data?.pagination?.total || 0;
  const hasNextPage = educationsData?.data?.pagination?.hasNextPage || false;
  const currentPageNumber =
    educationsData?.data?.pagination?.page || currentPage;

  // Get selected degree label for display
  const getSelectedDegreeLabel = () => {
    if (!selectedDegree) return "All";
    const degree = degrees?.find((d) => d.value === selectedDegree);
    return degree ? degree.label : "All";
  };

  // Calculate counts for filter buttons
  const getCounts = () => {
    const counts = { all: totalCount };

    // If we have total counts per degree from API, use those
    if (educationsData?.data?.countsByDegree) {
      educationsData.data.countsByDegree.forEach((item) => {
        counts[item.degreeId] = item.count;
      });
    }

    return counts;
  };

  const counts = getCounts();

  // Calculate display range for results summary
  const getDisplayRange = () => {
    if (educations.length === 0) return { start: 0, end: 0 };

    const limit = educationsData?.data?.pagination?.limit || 8;
    const start = (currentPageNumber - 1) * limit + 1;
    const end = Math.min(start + educations.length - 1, totalCount);

    return { start, end };
  };

  const { start, end } = getDisplayRange();

  return (
    <>
      {/* Quote Section */}
      <div className="row justify-content-center">
        <div className="col-xxl-11 col-xl-10 col-lg-10">
          <div className="postbox__details-wrapper pt-50 pb-0">
            <div className="postbox__item text-center pb-0 pb-md-5">
              <i className="fas fa-quote-right"></i>
              <p>
                As an organization of professionals, SAP has a deep interest in
                aquaculture education. The strength of the foundation of modern
                aquaculture depends on the technical and managerial capabilities
                of those who are involved in aquaculture as an enterprise. Both
                educational institutions and continuing education programs
                should therefore be equipped to impart broad knowledge and
                specific skills in aquaculture.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Mission Section */}
      <div id="it-about" className="it-about-3-area fix pt-0 pb-50 p-relative">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-xl-12 col-lg-12 wow animate__fadeInRight"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <div className="it-about-3-mv-box">
                <div className="row">
                  <div className="col-xl-12 col-md-12">
                    <div className="it-about-3-mv-item">
                      <span className="it-about-3-mv-title">
                        SAP's intended mission in the field of aquaculture
                        education is as following:
                      </span>
                      <div className="col-xl-12 col-md-12">
                        <div className="it-about-4-list-wrap d-flex align-items-start">
                          <div className="it-about-5-list">
                            <ul style={{ backgroundColor: "transparent" }}>
                              <li className="pr-0 pb-10 text-black">
                                <i className="fa-regular fa-angles-right"></i>
                                Promote aquaculture as a viable and rewarding
                                career option for students completing secondary
                                and higher secondary school education and
                                provide guidance to higher educational programs
                                in aquaculture
                              </li>
                              <li className="pr-0 pb-10 text-black">
                                <i className="fa-regular fa-angles-right"></i>
                                Offer those students who are in a track of a
                                diploma or degree in aquaculture an option of
                                becoming a student member in SAP
                              </li>
                              <li className="pr-0 pb-10 text-black">
                                <i className="fa-regular fa-angles-right"></i>
                                Expose student members to internships and career
                                opportunities in the aquaculture industry
                              </li>
                              <li className="pr-0 pb-10 text-black">
                                <i className="fa-regular fa-angles-right"></i>
                                Seek opportunities to serve aquaculture
                                educational institutions through guest lecture
                                programs and in the review of academic programs,
                                course contents and delivery
                              </li>
                            </ul>
                          </div>
                        </div>
                        <Link className="ed-btn-theme mb-4" to="/student-login">
                          Apply for Student Membership
                          <i>
                            <RightArrow />
                          </i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Educational Programs Section with Filters - ADD REF HERE */}
      <div
        id="educational-programs"
        className="it-about-3-area fix pt-50 pb-100 p-relative"
        ref={educationalProgramsRef} // Attach ref to this section
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-8">
              <div className="it-section-title-box text-center pb-40">
                <h2 className="it-section-title">
                  Educational Programs & Institutions
                </h2>
                <p className="it-section-subtitle">
                  Explore aquaculture education opportunities across different
                  degree levels
                </p>
              </div>
            </div>
          </div>

          {/* Filter Buttons */}
          <div className="row justify-content-center mb-5">
            <div className="col-xl-10">
              <div className="it-filter-buttons-wrapper text-center">
                <div className="it-filter-buttons d-flex flex-wrap justify-content-center gap-3">
                  <button
                    className={`it-filter-btn ${
                      !selectedDegree ? "active" : ""
                    }`}
                    onClick={() => onDegreeFilter(null)}
                    disabled={isFetching}
                  >
                    <i className="fa-solid fa-grid-2"></i>
                    All Programs
                    <span className="filter-count">({totalCount})</span>
                  </button>
                  {degrees?.map((degree) => {
                    const count = counts[degree.value] || 0;
                    return (
                      <button
                        key={degree.value}
                        className={`it-filter-btn ${
                          selectedDegree === degree.value ? "active" : ""
                        }`}
                        onClick={() => onDegreeFilter(degree.value)}
                        disabled={isFetching}
                      >
                        <i className="fa-solid fa-graduation-cap"></i>
                        {degree.label}
                        {count > 0 && (
                          <span className="filter-count">({count})</span>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* Rest of your existing code remains the same... */}
          {/* Results Summary */}
          <div className="row justify-content-center mb-4 mt-4">
            <div className="">
              <div className="">
                <p className="mb-0 text-muted">
                  {totalCount > 0 ? (
                    <>
                      Showing{" "}
                      <span className="fw-medium">
                        {start} - {end}
                      </span>{" "}
                      of{" "}
                      <span className="fw-medium text-primary">
                        {totalCount}
                      </span>{" "}
                      programs
                      {selectedDegree && (
                        <span className="text-primary fw-medium">
                          {" "}
                          in {getSelectedDegreeLabel()}
                        </span>
                      )}
                      {totalPages > 1 && (
                        <span className="text-muted">
                          {" "}
                          (Page {currentPageNumber} of {totalPages})
                        </span>
                      )}
                    </>
                  ) : (
                    <span>No programs available</span>
                  )}
                </p>
              </div>
            </div>
          </div>

          {/* Education Cards */}
          <div className="row g-4">
            {educations.length > 0 ? (
              educations.map((education, index) => (
                <div
                  key={education._id}
                  className="col-xl-6 col-lg-6 col-md-12"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="p-3 border rounded-3 bg-white shadow-sm h-100">
                    {/* Header */}
                    <div className="d-flex align-items-start justify-content-between mb-3">
                      <div>
                        <h5 className="mb-1 text-dark fw-bold lh-sm">
                          {education.course}
                        </h5>
                        <div className="d-flex align-items-center text-muted">
                          <i className="fa-solid fa-university me-2 text-primary opacity-75"></i>
                          <span className="small fw-medium">
                            {education.university}
                          </span>
                        </div>
                      </div>
                      <span className="badge bg-primary text-white bg-opacity-10 rounded-pill px-3 py-2 fw-medium border border-primary border-opacity-25">
                        {education.degree?.name || "N/A"}
                      </span>
                    </div>

                    {/* Location */}
                    <div className="d-flex align-items-center mb-2">
                      <div className="icon-wrapper me-2">
                        <i className="fa-solid fa-map-marker-alt text-success bg-success bg-opacity-10 p-2 rounded-circle"></i>
                      </div>
                      <span className="text-dark fw-medium">
                        {education.place}
                      </span>
                    </div>

                    {/* Website */}
                    {education.website && (
                      <a
                        href={education.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-primary btn-sm rounded-pill mt-2 d-inline-flex align-items-center gap-2 px-3 py-2"
                      >
                        <i className="fa-solid fa-external-link-alt fs-7"></i>
                        <span className="fw-medium">Visit Website</span>
                      </a>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center py-5">
                <div className="it-no-results">
                  <div className="mb-4">
                    <i
                      className="fa-solid fa-graduation-cap text-muted opacity-50"
                      style={{ fontSize: "4rem" }}
                    ></i>
                  </div>
                  <h4 className="text-dark fw-bold mb-3">
                    {isFetching ? "Loading Programs..." : "No Programs Found"}
                  </h4>
                  <p className="text-muted mb-0 fs-6">
                    {isFetching
                      ? "Please wait while we fetch the programs..."
                      : selectedDegree
                      ? `No educational programs found for ${getSelectedDegreeLabel()}. Try selecting a different degree level or check back later.`
                      : "No educational programs are currently available. Please check back later or contact us for more information."}
                  </p>
                  {!isFetching && selectedDegree && (
                    <button
                      className="btn btn-outline-primary mt-3"
                      onClick={() => onDegreeFilter(null)}
                    >
                      View All Programs
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && !isFetching && educations.length > 0 && (
            <div className="row justify-content-center mt-5">
              <div className="col-12">
                <div className="d-flex justify-content-center">
                  <Pagination
                    currentPage={currentPageNumber}
                    totalPages={totalPages}
                    onPageChange={onPageChange}
                    showPages={5}
                  />
                </div>
                {/* Pagination Summary */}
                <div className="text-center mt-3">
                  <small className="text-muted">
                    Page {currentPageNumber} of {totalPages} • {totalCount}{" "}
                    total programs
                    {hasNextPage && " • More results available"}
                  </small>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Keep all your existing styles */}
      <style jsx>{`
        /* All your existing styles remain the same */
        .it-filter-buttons-wrapper {
          background: linear-gradient(135deg, #f8f9ff 0%, #f0f0ff 100%);
          border-radius: 15px;
          padding: 25px;
          margin-bottom: 20px;
          border: 1px solid rgba(112, 79, 230, 0.1);
          box-shadow: 0 2px 10px rgba(112, 79, 230, 0.05);
        }

        .it-filter-btn {
          background: #ffffff;
          border: 2px solid #e9ecef;
          border-radius: 25px;
          padding: 12px 24px;
          font-weight: 600;
          color: #6c757d;
          transition: all 0.3s ease;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          min-height: 44px;
          white-space: nowrap;
        }

        .it-filter-btn:hover:not(:disabled) {
          background: #704fe6;
          border-color: #704fe6;
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(112, 79, 230, 0.3);
        }

        .it-filter-btn.active {
          background: #704fe6;
          border-color: #704fe6;
          color: white;
          box-shadow: 0 5px 15px rgba(112, 79, 230, 0.4);
        }

        .it-filter-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .filter-count {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 12px;
          padding: 2px 8px;
          font-size: 12px;
          font-weight: 500;
          margin-left: 4px;
        }

        .it-filter-btn.active .filter-count {
          background: rgba(255, 255, 255, 0.3);
        }

        .it-filter-btn:not(.active) .filter-count {
          background: rgba(112, 79, 230, 0.1);
          color: #704fe6;
        }

        .it-results-summary {
          padding: 15px 20px;
          background: rgba(112, 79, 230, 0.05);
          border-radius: 10px;
          border: 1px solid rgba(112, 79, 230, 0.1);
        }

        .it-education-card {
          background: #ffffff;
          border-radius: 12px;
          transition: all 0.3s ease;
          overflow: hidden;
          border: 1px solid rgba(112, 79, 230, 0.1);
          animation: fadeInUp 0.6s ease-out forwards;
          opacity: 0;
          transform: translateY(20px);
        }

        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .it-education-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 40px rgba(112, 79, 230, 0.15) !important;
          border-color: rgba(112, 79, 230, 0.3);
        }

        .it-education-card-header {
          background: linear-gradient(
            135deg,
            rgba(112, 79, 230, 0.05) 0%,
            rgba(112, 79, 230, 0.02) 100%
          );
          border-bottom: 1px solid rgba(112, 79, 230, 0.1) !important;
        }

        .it-website-link {
          color: #704fe6;
          font-weight: 500;
          font-size: 14px;
          padding: 8px 16px;
          background: rgba(112, 79, 230, 0.1);
          border-radius: 20px;
          display: inline-flex;
          align-items: center;
          transition: all 0.3s ease;
          text-decoration: none !important;
        }

        .it-website-link:hover {
          background: #704fe6;
          color: white !important;
          text-decoration: none;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(112, 79, 230, 0.3);
        }

        .text-primary {
          color: #704fe6 !important;
        }

        .bg-primary {
          background-color: #704fe6 !important;
        }

        .border-primary {
          border-color: #704fe6 !important;
        }

        .it-no-results {
          padding: 60px 20px;
        }

        .it-no-results i {
          color: #704fe6 !important;
          opacity: 0.3;
        }

        .ed-btn-theme {
          background: linear-gradient(135deg, #704fe6 0%, #8a6ce9 100%);
          border: none;
          color: white;
          padding: 12px 30px;
          border-radius: 25px;
          font-weight: 600;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          transition: all 0.3s ease;
        }

        .ed-btn-theme:hover {
          background: linear-gradient(135deg, #5a3ed4 0%, #704fe6 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(112, 79, 230, 0.4);
          color: white;
          text-decoration: none;
        }

        .it-section-title {
          color: #704fe6;
          font-weight: 700;
        }

        .it-about-3-mv-title {
          color: #704fe6;
          font-weight: 600;
        }

        .it-about-5-list ul li i {
          color: #704fe6;
        }

        .spinner-border-sm {
          width: 1rem;
          height: 1rem;
        }

        .opacity-75 {
          opacity: 0.75;
        }

        .icon-wrapper {
          flex-shrink: 0;
        }

        .hover-lift {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .transition-all {
          transition: all 0.3s ease;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .it-filter-buttons {
            flex-direction: column;
            align-items: center;
          }

          .it-filter-btn {
            width: 100%;
            justify-content: center;
            max-width: 300px;
            margin-bottom: 10px;
          }

          .it-filter-buttons-wrapper {
            padding: 20px 15px;
          }

          .it-education-card {
            margin-bottom: 20px;
          }

          .it-results-summary {
            font-size: 14px;
            padding: 12px 15px;
          }
        }

        @media (max-width: 576px) {
          .it-education-card-header {
            padding: 15px;
          }

          .it-education-card-body {
            padding: 15px;
          }

          .it-filter-btn {
            font-size: 13px;
            padding: 10px 20px;
            gap: 6px;
          }
        }

        /* Print Styles */
        @media print {
          .it-filter-buttons-wrapper,
          .it-results-summary,
          .pagination {
            display: none;
          }

          .it-education-card {
            break-inside: avoid;
            box-shadow: none;
            border: 1px solid #ddd;
          }
        }
      `}</style>
    </>
  );
};

export default EducationSection;
